"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var TypesenseError_1 = tslib_1.__importDefault(require("./TypesenseError"));
var ObjectUnprocessable = /** @class */ (function (_super) {
    tslib_1.__extends(ObjectUnprocessable, _super);
    function ObjectUnprocessable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ObjectUnprocessable;
}(TypesenseError_1.default));
exports.default = ObjectUnprocessable;
//# sourceMappingURL=ObjectUnprocessable.js.map